module.exports = __webpack_public_path__ + "static/img/F03-合肥上海世界外国语学校.288a971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/F03-合肥上海世界外国语学校.png
// module id = JfvA
// module chunks = 0